import { Link } from "@/components/common/Link";
import { MapPin } from "lucide-react";
const cities = ["Fort Lauderdale", "Hollywood", "Pompano Beach", "Coral Springs", "Pembroke Pines", "Davie", "Plantation", "Sunrise", "Deerfield Beach", "Miramar"];
export default function ServiceAreasPreview() {
  return <section data-section-id="242776" id="service-areas" className="bg-background text-foreground py-12 md:py-16 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center justify-center space-y-6 text-center">
          <div className="flex items-center gap-2">
            <MapPin className="size-5 text-primary" aria-hidden="true" />
            <h3 className="font-default text-xl md:text-2xl font-semibold text-foreground tracking-tight">
              Serving Broward County Communities
            </h3>
          </div>
          
          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 max-w-4xl">
            {cities.map((city, i) => <div key={city} data-index={i} className="flex items-center">
                <Link to="/BrowardCountyHomeInspectorPage" className="text-base text-muted-foreground hover:text-primary transition-colors font-default font-medium">
                  {city}
                </Link>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}